import * as type from "./types";
import { updateObject } from "../../utils/utility";
import {Policy, initialPolicy} from "../../model/policy";

const storePolicy = (state: Policy, action: type.ActionType) => {
    return updateObject(
        state,
        action.data
    )
}
const setAgentCode = (state: Policy, action: any) => {
    return updateObject(
        state,
        { agentCode: action.agentCode }
    )
}

export const policyReducer = (state: Policy = initialPolicy, action: type.ActionType) => {
    switch ( action.type ) {
        case type.POLICY_STORE:
            return storePolicy(state, action);
        case type.POLICY_FETCH_FAILED:
            return updateObject(
                state,
                { error: true }
            );
        case type.SET_AGENT_CODE:
            return setAgentCode(state, action);
        default:
            return state;
    }
}
